module.exports = __webpack_public_path__ + "static/img/egg_g_08.fd549e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_08.png
// module id = a3p3
// module chunks = 1